require('./messenger.css');

import translator from './Translator';

function createToast(type, labelCode, sticky, labelParam) {
    var options = {
        text: labelParam ? translator.translateParam(labelCode, labelParam) : translator.translate(labelCode),
        type: type,
        sticky: typeof sticky !== 'undefined' ? sticky : (type === 'error'),
        stayTime: 10000
    };
    $().toastmessage('showToast', options);
}

export class Messenger {
    notice(labelCode, sticky?, labelParam?) {
        createToast('notice', labelCode, sticky, labelParam);
    }

    success(labelCode, sticky?, labelParam?) {
        createToast('success', labelCode, sticky, labelParam);
    }

    error(labelCode, sticky?, labelParam?) {
        createToast('error', labelCode, sticky, labelParam);
    }

    warning(labelCode, sticky?, labelParam?) {
        createToast('warning', labelCode, sticky, labelParam);
    }
}

export default new Messenger();


// WEBPACK FOOTER //
// ./src/main/ui/core/application/Messenger.ts